import { Typography } from "@mui/material";
import { Column, MedicationTitration } from "src/api/types";
import StatusIndicator from "src/shared/StatusIndicator";

export const useColumns = (): Column<MedicationTitration>[] => {
  return [
    {
      id: "active",
      label: "Active",
      minWidth: 50,
      align: "center",
      orderable: false,
      format: (row) => row.medication.active.toString(),
      render: (row) => {
        let active: boolean = row.medication.active;

        if (!row.pharmacy.active) {
          active = false;
        }

        return <StatusIndicator status={active} />;
      },
    },
    {
      id: "priority",
      label: "Priority",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.priority.toString(),
      render: (row) => <Typography>{row.priority}</Typography>,
    },
    {
      id: "pharmacy_name",
      label: "Pharmacy",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.pharmacy.name.toString(),
      render: (row) => <Typography>{row.pharmacy.name}</Typography>,
    },
    {
      id: "medication",
      label: "Medication",
      align: "center",
      orderable: false,
      minWidth: 100,
      format: (row) => row.medication.name.toString(),
      render: (row) => <Typography>{row.medication.name}</Typography>,
    },
    {
      id: "dosage",
      label: "Dosage",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.medication.dosage.toString(),
      render: (row) => (
        <Typography>{`${row.medication.dosage} ${row.medication.dispense_unit}`}</Typography>
      ),
    },
    {
      id: "quantity",
      label: "Vial Quantity",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.quantity.toString(),
      render: (row) => <Typography>{row.quantity}</Typography>,
    },
  ];
};
